import {NgModule} from '@angular/core';
import {provideRouter, RouterModule, Routes} from '@angular/router';
import {environment} from '@environments/environment';
import {accountGuard} from './auth-config/guards/account.guard';
import {authGuard} from './auth-config/guards/auth.guard';
import {managerGuard} from './auth-config/guards/manager.guard';
import {security2FAGuard} from './auth-config/guards/security2FA.guard';
import {userGuard} from './auth-config/guards/user.guard';
import {maintenanceDeactivateModeGuard, maintenanceModeGuard} from './maintenance-mode/guards/maintenance-mode.guard';
import {SearchResultsComponent} from './shared/components/search-results/search-results.component';
import {DemoComponent} from './shared/pages/demo/demo.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'my-orders',
    pathMatch: 'full',
  },
  ...(environment.production
    ? []
    : [
        {
          path: 'demo',
          component: DemoComponent,
        },
      ]),
  {
    path: 'signup',
    loadChildren: () => import('./signUp/sign-up-routing.module').then(m => m.SignUpRoutingModule),
    canActivate: [maintenanceModeGuard],
  },
  {
    path: 'my-orders',
    loadChildren: () => import('./order/order-routing.module').then(m => m.OrderRoutingModule),
    canActivate: [authGuard, userGuard, accountGuard, maintenanceModeGuard],
  },
  {
    path: 'category',
    loadChildren: () => import('./category/category.routing.module').then(m => m.CategoryRoutingModule),
    canActivate: [authGuard, userGuard, accountGuard, maintenanceModeGuard],
  },
  {
    path: 'product',
    loadChildren: () => import('./product/product.routing.module').then(m => m.ProductRoutingModule),
    canActivate: [authGuard, userGuard, accountGuard, maintenanceModeGuard],
  },
  {
    path: 'search-results',
    component: SearchResultsComponent,
    title: 'Search Results',
    canActivate: [userGuard, accountGuard, maintenanceModeGuard],
  },
  {
    path: 'accounts',
    loadChildren: () => import('./accounts/accounts.routing.module').then(m => m.AccountsRoutingModule),
    canActivate: [managerGuard],
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.routing.module').then(m => m.CheckoutRoutingModule),
    canActivate: [userGuard, accountGuard, maintenanceModeGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth-config/auth-config-routing.module').then(m => m.AuthConfigRoutingModule),
    canActivate: [maintenanceModeGuard],
  },

  {
    path: 'static-pages',
    loadChildren: () => import('./static-pages/static-pages-routing.module').then(m => m.StaticPagesRoutingModule),
    canActivate: [maintenanceModeGuard],
  },
  {
    path: 'mfa-setup',
    loadChildren: () => import('./mfa-setup/routes').then(m => m.MFA_ROUTES),
    canActivate: [userGuard, security2FAGuard, maintenanceModeGuard],
  },
  {
    path: 'maintenance-mode',
    loadChildren: () =>
      import('./maintenance-mode/maintenance-mode-routing.module').then(m => m.MaintenanceModeRoutingModule),
    canActivate: [maintenanceDeactivateModeGuard],
  },
  {
    path: '**',
    loadChildren: () => import('./page-not-found/page-not-found-routing.module').then(m => m.PageNotFoundRoutingModule),
    canActivate: [maintenanceModeGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [provideRouter(routes)],
})
export class AppRoutingModule {}
